import { createContext, useState, useEffect } from "react"
import { PreviewInternalActModel } from "../models/Act"

const InternalFormContext = createContext({})

export const FormProvider = ({ children }) => {

    const title = {
        1: 'Основни подаци',
        3: 'Везе',
        4: 'Остало',
        5: 'Историјат измена'
    }

    const [page, setPage] = useState('1');

    const [data, setData] = useState(new PreviewInternalActModel());

    const handleChangeInput = e => {
        const type = e.target.type;
        const name = e.target.name;
        const model = e.target.getAttribute("data-model");
        
        const value = type === "checkbox"
            ? e.target.checked
            : e.target.value;

            setData(prevData => {
                const newData = {...prevData}
                newData[model][name] = value;
                return newData;
            })
    };

    const handleChangeList = e => {
        const name = e.name;
        const value = e.value;
        const model  = e.model;
        setData(prevData => {
            const newData = {...prevData}
            newData[model][name] = value;
            return newData;
        })
    };

    const handleChangeDate = (date, name, model) => {
        setData(prevData => {
            const newData = {...prevData}
            newData[model][name] = date;
            return newData;
        })
    };

    const handleChangePage = (event, newValue) => {
        setPage(newValue);
      };
    
    return (
        <InternalFormContext.Provider value={{title, page, handleChangePage, data, setData, handleChangeInput, handleChangeList, handleChangeDate }}>
            {children}
        </InternalFormContext.Provider>
    )
}

export default InternalFormContext;